import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { createAction, createFeatureSelector, createReducer, createSelector, on, props } from '@ngrx/store';
import { catchError, map, of, switchMap } from 'rxjs';
import { EdicaoPublicadaPortalOutputDto } from 'src/app/domain/DTOs/output/publicacao/edicao-publicada-portal-output.dto';
import { EdicaoPublicadaService } from 'src/app/services/edicao-publicada.service';
import { CommonMessages } from 'src/app/utils/common.messages';

const actionName = '[Obter Última Edição Publicada]';

export const obterUltimaEdicaoPublicada = createAction(`${actionName} Obter`);
export const obterUltimaEdicaoPublicadaSuccess = createAction(`${actionName} Sucesso`, props<{ response: EdicaoPublicadaPortalOutputDto }>());
export const obterUltimaEdicaoPublicadaFailure = createAction(`${actionName} Falha`, props<{ erro: string }>());
export const obterUltimaEdicaoPublicadaFinish = createAction(`${actionName} Concluir`);

export interface ObterUltimaEdicaoPublicadaState {
  response: EdicaoPublicadaPortalOutputDto | null;
  error: string | null;
  carregando: boolean;
}

const initialState: ObterUltimaEdicaoPublicadaState = { response: null, error: null, carregando: false };

// -- Reducer
export const obterUltimaEdicaoPublicadaReducer = createReducer(
  initialState,
  on(obterUltimaEdicaoPublicada, state => ({ ...state, response: null, error: null, carregando: true })),
  on(obterUltimaEdicaoPublicadaSuccess, (state, { response }) => ({ ...state, response, error: null, carregando: false })),
  on(obterUltimaEdicaoPublicadaFailure, (state, { erro }) => ({ ...state, response: null, error: erro, carregando: false })),
  on(obterUltimaEdicaoPublicadaFinish, () => initialState)
);

// -- Selector
export const selectObterUltimaEdicaoPublicadaState = createFeatureSelector<ObterUltimaEdicaoPublicadaState>('obterUltimaEdicaoPublicada');
export const selectDadosObterUltimaEdicaoPublicada = createSelector(selectObterUltimaEdicaoPublicadaState, state => state.response);
export const selectCarregandoObterUltimaEdicaoPublicada = createSelector(selectObterUltimaEdicaoPublicadaState, state => state.carregando);
export const selectErrosObterUltimaEdicaoPublicada = createSelector(selectObterUltimaEdicaoPublicadaState, state => state.error);

// -- Effect
@Injectable()
export class ObterUltimaEdicaoPublicadaEffects {
  obterUltimaEdicaoPublicada$ = createEffect(() => this.actions$.pipe(
    ofType(obterUltimaEdicaoPublicada),
    switchMap(() => this.edicaoPublicadaService.obterUltimaEdicao().pipe(
      map(response => response.erros?.length
        ? obterUltimaEdicaoPublicadaFailure({ erro: response.erros[0] })
        : response.dados
          ? obterUltimaEdicaoPublicadaSuccess({ response: response.dados })
          : obterUltimaEdicaoPublicadaFailure({ erro: CommonMessages.EdicaoHtml.SemEdicaoTitulo })),
      catchError(() => of(obterUltimaEdicaoPublicadaFailure({ erro: CommonMessages.EdicaoHtml.CarregarUltimaEdicao })))
    ))
  ));

  constructor(private readonly actions$: Actions, private readonly edicaoPublicadaService: EdicaoPublicadaService) {}
}
